import { useSortable } from '@dnd-kit/sortable'
import type { UniqueIdentifier } from '@dnd-kit/core'

type SortableItemProps = {
  id: UniqueIdentifier
  children: React.ReactNode
  isDragging: boolean
}

export function SortableItem({ id, children, isDragging }: SortableItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    zIndex: isDragging ? 1000 : 'auto',
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners} className="relative inline-block">
      {children}
    </div>
  )
}
